import React, {useEffect} from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {itemTypeEnum} from "../../enums";
import Utility from "../../Utility";
import {useStores} from "../../Hooks";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {ProcedureRequester} from "../../MobxStores/RequestApi/ProcedureRequester";

const DeleteMediaItemsModal = observer(() => {
    const {modalStore, generalStore, projectStore, editorStore} = useStores();
    const [warningMessage, setWarningMessage] = React.useState('Warning:DeletingAFolderWillDeleteAllIt\'sFoldersAndFiles!');

    useEffect(() => {
        if (modalStore.isDeleteMediaItemsModalOpen && modalStore.modalData.itemsToDelete) {
            checkIsFileUsed().then((data) => {
                if (data.used) {
                    setWarningMessage(`ThisFileIsAttachedTo ${data?.procedure?.ProcedureName}InVersion - ${data?.procedure?.CurrentVersion || data?.procedure?.Version}.AreYouSureYouWantToDeleteIt?`)
                }
            }).catch((e) => {
                console.log(e);
            });
        }
        // eslint-disable-next-line
    }, [modalStore.isDeleteMediaItemsModalOpen]);

    async function checkIsFileUsed() {
        const {itemsToDelete} = modalStore.modalData
        return await ProcedureRequester.getUsedFileInProcedure(generalStore.workspace, itemsToDelete);
    }

    function closeModal() {
        modalStore.isDeleteMediaItemsModalOpen = false;
        delete modalStore.modalData.itemsToDelete;
        delete modalStore.modalData.afterDelete;
    }

    async function updateProgressLoader(uploaded, needToUpload, shouldClose = false) {
        if (shouldClose) {
            generalStore.progressLoaderValue = null;
            return;
        }
        generalStore.progressLoaderValue = 100 * (uploaded / needToUpload);
        generalStore.progressLoaderString = `${generalStore.translate('deleteMediaProgressSentence1_beforeCurrent')} ${uploaded} ${generalStore.translate('deleteMediaProgressSentence2_beforeTotal')} ${needToUpload}${generalStore.translate('deleteMediaProgressSentence3_afterTotal')}`;
        await Utility.sleep(200); // making it visible to the human eye
    }


    async function deleteFile(file) {
        try {
            await generalStore.deleteFile(file.FileId);
        } catch (e) {
            modalStore.showErrorMessage(`${generalStore.translate('cannotDeleteFile')}: ${file.FileName}`);
        }
    }

    async function deleteFolder(folder) {
        try {
            await generalStore.deleteFolder(folder._id);
        } catch (e) {
            modalStore.showErrorMessage(`${generalStore.translate('cannotDeleteFolder')}: ${folder.FolderName}`);
        }
    }

    async function deleteItems() {
        try {
            const {itemsToDelete, afterDelete} = modalStore.modalData
            const deleted = [0]; // array for thread safety
            const needToUpload = itemsToDelete.length;
            await updateProgressLoader(deleted[0], needToUpload)

            const promises = itemsToDelete.map(item => {
                let promise;
                if (item.type === itemTypeEnum.MEDIA_FOLDER) {
                    promise = deleteFolder(item);
                    projectStore.mediaLibraryPathArray = projectStore.mediaLibraryPathArray.filter(folder=>folder.folderId!==item._id);
                } else {
                    promise = deleteFile(item);
                }

                promise.then(async () => {
                    deleted[0]++;
                    await updateProgressLoader(deleted[0], needToUpload);
                });
                return promise;
            });

            await Promise.all(promises);
            await updateProgressLoader(0, 0, true);

            generalStore.isLoaderOpen = true;
            await afterDelete();
            closeModal()
            editorStore.refreshTrigger = !editorStore.refreshTrigger;
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('problemDeletingItems'));
            console.error(e);
        }

        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isDeleteMediaItemsModalOpen'
            className={modalStore.modalData.headerClassName ? 'delete-dialog-media' : 'delete-dialog'}
            onEnter={null}
            title={<div><WarningAmberIcon style={{marginTop: "40px", width: "35px", height: "35px", marginLeft: "60px", color: "#FF1F1F"}} /> <div>{generalStore.translate('confirmDelete')}</div></div>}
            body={
            <div style={{color: "#36415D", display: "flex", justifyContent: "center", alignItems:"center", marginTop: "40px", flexDirection: "column",  marginLeft: "60px",  marginRight: "60px"}}>
                <div className="dialog-description">
                    {generalStore.translate('AreYouSureYouWishToDeleteThoseItems?')}
                </div>
                <div className="dialog-description">
            {generalStore.translate(warningMessage)}
                </div>
            </div>
            }
            isConfirmDisabled={false}
            onConfirm={deleteItems}
            preserveDataOnClose
            confirmText={generalStore.translate('delete')}
            headerClassName={modalStore.modalData.headerClassName}
            buttonsClassName='center-buttons-media'
        />
    );
});


export default DeleteMediaItemsModal;
